mutation GetMultipleShareUrl(
    $campaignId: ID!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]!
    $reportingLabels: [String]!
) {
    getMultipleShareUrl(
        campaignId: $campaignId
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        reportingLabels: $reportingLabels
    ) {
        url
    }
}
